import type { Ref } from 'react';
import { forwardRef } from 'react';

import type { TIconSize } from '../icon.interface';

const InformationIcon = forwardRef(
  (
    { color = '#0B0B0B', ...props }: TIconSize & { color?: string },
    ref: Ref<SVGSVGElement>
  ) => {
    return (
      <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={ref}
        {...props}
      >
        <path
          d="M9.0013 7.33342C9.46154 7.33342 9.83464 7.70651 9.83464 8.16675V12.3334C9.83464 12.7937 9.46154 13.1667 9.0013 13.1667C8.54106 13.1667 8.16797 12.7937 8.16797 12.3334V8.16675C8.16797 7.70651 8.54106 7.33342 9.0013 7.33342Z"
          fill={color}
        />
        <path
          d="M9.0013 6.50008C9.46154 6.50008 9.83464 6.12699 9.83464 5.66675C9.83464 5.20651 9.46154 4.83342 9.0013 4.83342C8.54106 4.83342 8.16797 5.20651 8.16797 5.66675C8.16797 6.12699 8.54106 6.50008 9.0013 6.50008Z"
          fill={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.3346 9.00008C17.3346 4.39771 13.6037 0.666748 9.0013 0.666748C4.39893 0.666748 0.667969 4.39771 0.667969 9.00008C0.667969 13.6025 4.39893 17.3334 9.0013 17.3334C13.6037 17.3334 17.3346 13.6025 17.3346 9.00008ZM15.668 9.00008C15.668 5.31818 12.6832 2.33341 9.0013 2.33341C5.3194 2.33342 2.33464 5.31818 2.33464 9.00008C2.33464 12.682 5.3194 15.6667 9.0013 15.6667C12.6832 15.6667 15.668 12.682 15.668 9.00008Z"
          fill={color}
        />
      </svg>
    );
  }
);

export default InformationIcon;
